var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Rect, Path } from "react-native-svg";
function SvgEye(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    "data-name": "Tips - RTV Tipsters"
  }, /*#__PURE__*/React.createElement(Rect, {
    width: 15,
    height: 15,
    rx: 3,
    ry: 3,
    fill: "#1d1c39"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M7.62 6.21c-.79 0-1.43.62-1.43 1.39s.64 1.39 1.43 1.39 1.43-.62 1.43-1.39-.64-1.39-1.43-1.39zm0 3.9c-1.42 0-2.56-1.12-2.56-2.51s1.15-2.51 2.56-2.51 2.56 1.12 2.56 2.51-1.15 2.51-2.56 2.51zm0-6.41c-3.99 0-5.7 3.9-5.7 3.9s1.71 3.9 5.7 3.9 5.7-3.9 5.7-3.9-1.71-3.9-5.7-3.9z",
    fill: "#fff"
  }))));
}
export default SvgEye;